export class LoginReq {
    userName?: string;
    password?: string;

    constructor(
        userName?: string,
        password?: string,

    ) {
        this.userName = userName
        this.password = password

    }

}


export class ForgotPasswordReq {
    userName?: string;
    otp?: string

    constructor(
        userName?: string,
        otp?: string

    ) {
        this.userName = userName
        this.otp = otp

    }
}


export class ResetPasswordReq {
    userName?: string;
    password?: string

    constructor(
        userName?: string,
        password?: string


    ) {
        this.userName = userName
        this.password = password

    }
}

